import Modal from "react-modal";
import React from "react";
import { Formik, Form, Field } from "formik";
import { Stack, Button, TextField as MuiTextField } from "@mui/material";
import { TextField } from "formik-mui";
const ManifestReturnsModal = ({
  open,
  closeModal,
  item_id,
  row = {}, column
}) => {

  renderFormik = () => {
    return (
      <Formik
        key={`manifest-returns-form-${item_id}`}
        initialValues={{
          event_item_fields: {
            warehouse_received: (row.event_item_fields||{}).warehouse_received||0,
            damaged: (row.event_item_fields||{}).damaged||0,
            extra: (row.event_item_fields||{}).extra||0,
            lost_or_consumed: (row.event_item_fields||{}).lost_or_consumed||0,
          },
          quick_add: 0
        }}
        onSubmit={submitForm}
      >
        {renderForm}
      </Formik>
    )
  }

  const submitForm = (values, {
    setSubmitting
  }) => {
    changes = {
      warehouse_received: values.event_item_fields.warehouse_received,
      damaged: values.event_item_fields.damaged,
      extra: getExtraCount({values}),
      lost_or_consumed: getLostCount({values}),
    }

    row.updateEventItemField(row.event_item_fields.id, changes)
    closeModal()

  }


  const labelClasses = "text-stone-500 text-xs font-normal leading-none col-xs-12 col-md-3 "
  const rowClasses = "flex row mb-2 items-center"
  renderForm = (formikProps) => {
    return (
      <div>
        <div className={rowClasses}>
          <div className={labelClasses}>
            Returned
          </div>
          <div className="col-xs-12 col-md-9">
            <Field
              component={
                TextField
              }
              sx={{ width: "100%" }}
              name="event_item_fields[warehouse_received]"
              type="number"
              size="small"
              InputProps={{ inputProps: { min: 0 } }}
            />
          </div>
        </div>
        <div className={"mb-8 "+rowClasses}>
          <div className={labelClasses}>
            Quick Add
          </div>
          <div className="col-xs-12 col-md-5">
            <Field
              component={
                TextField
              }
              InputProps={{ inputProps: { min: 0 } }}
              sx={{ width: "100%" }}
              name="quick_add"
              type="number"
              size="small"
            />
          </div>
          <div className="col-xs-12 col-md-4">
            <Button
              type="button"
              onClick={()=>quickAdd(formikProps)}
            >
              + Quick Add
            </Button>
          </div>
        </div>
        <div className={rowClasses}>
          <div className={labelClasses}>
            Damaged
          </div>
          <div className="col-xs-12 col-md-9">
            <Field
              component={
                TextField
              }
              sx={{ width: "100%" }}
              name="event_item_fields[damaged]"
              size="small"
              type="number"
              InputProps={{ inputProps: { min: 0, max: formikProps.values.event_item_fields.warehouse_received} }}
            />
          </div>
        </div>
        <div>
          <hr/>
        </div>

        {renderComputedFields(formikProps)}
        {renderButtons(formikProps)}
      </div>
    )
  }

  const renderButtons = (formikProps) => {
    return (
      <div className="flex justify-end mt-4">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="mr-2"
          onClick={formikProps.submitForm}
          disabled={formikProps.isSubmitting}
        >
          Save As Draft
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={closeModal}
        >
          Cancel
        </Button>
      </div>
    )
  }

  const renderComputedFields = (formikProps) => {
    return (
      <div>
        <div className={rowClasses}>
          <div className={labelClasses}>
            Lost/Consumed
          </div>
          <div className="col-xs-12 col-md-9">
            <MuiTextField
              sx={{ width: "100%" }}
              value={getLostCount(formikProps)}
              size="small"
              InputProps={{ inputProps: { min: 0 } }}
              disabled
            />
          </div>
        </div>
        <div className={rowClasses}>
          <div className={labelClasses}>
            Extra
          </div>
          <div className="col-xs-12 col-md-9">
            <MuiTextField
              sx={{ width: "100%" }}
              value={getExtraCount(formikProps)}
              size="small"
              InputProps={{ inputProps: { min: 0 } }}
              disabled
            />
          </div>
        </div>
        <hr/>
        <div className={rowClasses}>
          <div className={labelClasses}>
            Net Total Returned
          </div>
          <div className="col-xs-12 col-md-9">
            <MuiTextField
              sx={{ width: "100%" }}
              value={getNetTotal(formikProps)}
              size="small"
              InputProps={{ inputProps: { min: 0 } }}
              disabled
            />
          </div>
        </div>
      </div>
    )
  }

  const getNetTotal = (formikProps) => {
    return (formikProps.values.event_item_fields.warehouse_received || 0) - (formikProps.values.event_item_fields.damaged || 0)
  }

  const getLostCount = (formikProps) => {
    return Math.max(getTotalReservedCount() - (formikProps.values.event_item_fields.warehouse_received||0), 0)
  }

  const getTotalReservedCount = (formikProps) => {
    return (row.total_count_including_filtered_items||0)
  }
  
  const getExtraCount = (formikProps) => {
    if(getTotalReservedCount() < formikProps.values.event_item_fields.warehouse_received) {
      return (formikProps.values.event_item_fields.warehouse_received - getTotalReservedCount())
    }
    return 0
  }
              

  const quickAdd = (formikProps) => {
    if(formikProps.values.quick_add > 0) {
      formikProps.setFieldValue("event_item_fields[warehouse_received]", formikProps.values.event_item_fields.warehouse_received + formikProps.values.quick_add)
      formikProps.setFieldValue("quick_add", 0)
    }
  }

  return (
    <Modal
      className="react-modal sg-manifest-list-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      //onRequestClose={closeModal}
      contentLabel=""
    >
      <div class="justify-start text-stone-500 text-xs font-normal leading-none">RECIEVED ITEM:</div>
      <div class="justify-start text-blue-600 text-lg font-normal">
        {row.name}
      </div>
      <div class="justify-start text-blue-600 font-normal text-xs mb-4">
        Shipped:{getTotalReservedCount()||0}, Collected: {(row.event_item_fields||{}).collected||0}
      </div>

      {renderFormik()} 
    </Modal>
  )
}

export default ManifestReturnsModal